import { useMemo } from "react";

import { Code } from "components/icons/generated";
import { AccountContext } from "views/AccountWrapper";
import useSelfServiceFlags from "hooks/useSelfServiceFlags";
import useTypedFlags from "hooks/useTypedFlags";
import useTypedContext from "hooks/useTypedContext";

import type { MainNavigationItem } from "../types";
import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";

const useShareCodeConfigGroup = (): MainNavigationItem => {
  const { viewer } = useTypedContext(AccountContext);
  const { sharingModulesBetweenSpaces, spaceliftVcsUi } = useTypedFlags();
  const { enableSelfServiceV2 } = useSelfServiceFlags();

  return useMemo(
    () => ({
      id: "share-code-config",
      title: "Share Code & Config",
      icon: Code,
      items: [
        {
          items: [
            ...(sharingModulesBetweenSpaces
              ? [
                  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[
                    MainNavigationPrimaryMenuItemKeys.ModuleRegistry
                  ],
                  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Providers],
                  ...(viewer.admin
                    ? [
                        MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[
                          MainNavigationPrimaryMenuItemKeys.GPGKeys
                        ],
                      ]
                    : []),
                ]
              : [MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Registry]]),
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Contexts],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Blueprints],
            ...(enableSelfServiceV2
              ? [
                  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[
                    MainNavigationPrimaryMenuItemKeys.TemplateWorkbench
                  ],
                ]
              : []),
            ...(spaceliftVcsUi
              ? [MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.SpaceliftVcs]]
              : []),
          ],
        },
      ],
    }),
    [sharingModulesBetweenSpaces, viewer.admin, enableSelfServiceV2, spaceliftVcsUi]
  );
};

export default useShareCodeConfigGroup;
